var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHolidayCalendarDisplay = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_500_74142)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 12,
  fill: "white"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_500_74142)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.5 15.5L19 16.5V15.5L16.5 14.25V13C16.5 12.8674 16.4473 12.7402 16.3536 12.6464C16.2598 12.5527 16.1326 12.5 16 12.5C15.8674 12.5 15.7402 12.5527 15.6464 12.6464C15.5527 12.7402 15.5 12.8674 15.5 13V14.25L13 15.5V16.5L15.5 15.5V17.25L14.5 18V18.5L16 18L17.5 18.5V18L16.5 17.25V15.5Z",
  fill: "#A56EFF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17 6H15V5H14V6H10V5H9V6H7C6.73478 6 6.48043 6.10536 6.29289 6.29289C6.10536 6.48043 6 6.73478 6 7V17C6 17.2652 6.10536 17.5196 6.29289 17.7071C6.48043 17.8946 6.73478 18 7 18H12V17H7V7H9V8H10V7H14V8H15V7H17V10.5H18V7C18 6.73478 17.8946 6.48043 17.7071 6.29289C17.5196 6.10536 17.2652 6 17 6Z",
  fill: "#A56EFF"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_500_74142"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 12,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_500_74142"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(4 4)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHolidayCalendarDisplay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/holiday-calendar-display.62301a7321f926278ef9652ecd82c202.svg";